import React from 'react'
import { IApplicationState } from 'components/store/types'
import { getCurrentClinique } from 'components/core/state/selectors'
import { connect, ConnectedProps } from 'react-redux'
import CliniqueInfoLine from 'components/ui/CliniqueInfoLine'
import EmailIcon from '@mui/icons-material/Email'
import PhoneIcon from '@mui/icons-material/Phone'
import RoomIcon from '@mui/icons-material/Room'
import getCliniqueAddress from 'utils/getCliniqueAddress'

const mapState = (state: IApplicationState) => ({
  clinique: getCurrentClinique(state),
})
const connector = connect(mapState)

const CliniqueInfos = ({ clinique }: ConnectedProps<typeof connector>) => clinique && (
  <div className="tw-col-span-12 tw-grid tw-grid-cols-12 tw-my-4">
    <div className="tw-col-span-12 md:tw-col-span-6 tw-mb-2 md:tw-pr-2">
      <CliniqueInfoLine Icon={RoomIcon} label={getCliniqueAddress(clinique, true)} />
      {!!clinique.acf.phone && <CliniqueInfoLine Icon={PhoneIcon} label={clinique.acf.phone} type="tel" />}
      {!!clinique.acf.email && <CliniqueInfoLine Icon={EmailIcon} label={clinique.acf.email} type="mailto" />}
    </div>
    <div className="tw-col-span-12 md:tw-col-span-6 md:tw-pl-2 tw-text-lg">{clinique.acf.short_description}</div>
  </div>
)
export default connector(CliniqueInfos)
